var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48258 7.79146L5.80834 10.2447C6.17594 10.9249 6.93624 11.292 7.69749 11.1543L7.94295 11.1153C8.70164 10.9863 9.46194 11.3534 9.8321 12.025L11.4773 15.0692C11.5978 15.2922 11.5183 15.5585 11.2953 15.679C11.2507 15.7031 11.2087 15.7186 11.1606 15.723L8.98069 16.1014C7.31399 16.3898 5.64648 15.5837 4.84499 14.1006L1.22927 7.4101C0.355469 5.79322 0.468357 3.816 1.52627 2.30778L2.83088 0.442927C2.9748 0.242685 3.25115 0.194191 3.45396 0.329521C3.50895 0.364634 3.55626 0.425514 3.59498 0.483831L5.19192 3.43882C5.55952 4.11903 5.45005 4.9562 4.9178 5.51758L4.75068 5.70155C4.22189 6.28268 4.11242 7.11985 4.48258 7.79146Z",
    fill: "#6C757D"
  })));
}

export default SvgPhoneIcon;